import React from 'react'
import {connect} from 'react-redux'
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import logo from '../images/large_tree_logo.png'
import {save} from '../store'
import {post} from '../components/utils'
import "../hint.css"

class SinoInput extends React.Component{
    constructor() {
        super();
        this.state = {
            part1: "",
            nino: "", 
            isNino1Error: false
        }
    }

    part1(e){
        let v=e.target.value.toUpperCase()
        if ( v.length > 6 ) return
        this.setState( {part1: v} )
        this.setState({ isNino1Error: ! /^\d+$/.test(v) })

        if (v.length === 0) {
            this.refs.part1.focus()
            this.setState({ isNino1Error: false})
            this.props.onChange(false)
        }
        if (v.length === 6 ) {
            if ( /^\d+$/.test(v) ) {
                this.setState({ isNino1Error: false })
                this.props.onChange(true)
            }else{
                this.props.onChange(false)
            }
        } else {
            this.props.onChange(false)
        }
    }

    nino(){
        return this.refs.part1.value
    }

    componentDidMount() {        
        this.refs.part1.focus()
    }

    render() {
        return(
            <div className="nino">
                <span className={`hint--top hint--medium ${this.state.isNino1Error ? "hint--error" : ""}`} data-hint="6 Numbers of SI number, e.g 123456">
                    <input name="nino_1" ref="part1" type="text" maxLength="6" disabled={this.props.show_spinner}
                        minLength="6" size="6" placeholder="123456" value={this.state.part1} onChange={(e) => this.part1(e)}/>
                </span>
                <br/>
            </div>
            
        )
    }
}


class NinoInput extends React.Component{
    constructor() {
        super();
        this.state = {
            part1: "", 
            part2: "", 
            part3: "", 
            nino: "", 
            isNino1Error: false,
            isNino2Error: false,
            isNino3Error: false
        }
    }


    part1(e){
        let v=e.target.value.toUpperCase()
        if(v.length >2) return            
        this.setState( {part1: v})    
        let isNino1Error = !/^[A-Z]+$/.test(v)
        if( v.length === 0 ) isNino1Error = false
        
        if (v.length === 2 ) {
            if ( /^[A-Z]+$/.test(v)) {
                this.props.onChange(this.validateNino(v, this.refs.part2.value, this.refs.part3.value))
                this.refs.part2.focus()
                isNino1Error = null
            }
            else{
                this.props.onChange(false)
            }
        }else{
            this.props.onChange(false)
        }
        this.setState({part1: v, isNino1Error})
    }

    part2(e){
        let v=e.target.value.toUpperCase()
        if(v.length>6) return

        let isNino2Error = !/^\d+$/.test(v)

        if( v.length === 0 ) isNino2Error = false

        if (v.length === 0) {
            this.refs.part1.focus()
            this.props.onChange(false)
        }
        if (v.length === 6 ) {
            if ( /^\d+$/.test(v) ) {
                this.props.onChange(this.validateNino(this.refs.part1.value, v, this.refs.part3.value))
                this.refs.part3.focus()
            }else{
                isNino2Error = true
                this.props.onChange(false)
            }
        } else {
            this.props.onChange(false)
        }
        this.setState({part2: v, isNino2Error})
    }

    part3(e){
        let v=e.target.value.toUpperCase()

        if(v.length>1) return

        let isNino3Error = /^\d+$/.test(v)

        if( v.length === 0 ) isNino3Error = false

        
        if (v.length === 0) {
            this.refs.part2.focus()
            this.props.onChange(false)
        } else if (v.length === 1 ) {
            if ( this.part3IsValid(v) ) {
                this.props.onChange(this.validateNino(this.refs.part1.value, this.refs.part2.value, v))
            }else{
                isNino3Error = true
                this.props.onChange(false)
                this.refs.part3.focus()
            }
        } else {
            this.props.onChange(false)
        }
        this.setState({part3: v, isNino3Error})
    }

    nino(){
        return this.refs.part1.value + this.refs.part2.value + this.refs.part3.value
    }


    part1IsValid(v){
        return (v.length === 2 && /^[A-Z]+$/.test(v))
    }

    part2IsValid(v){
        return (v.length === 6 && /^\d+$/.test(v))
    }

    part3IsValid(v){
        return (v.length === 1 && /^[A-Z]+$/.test(v))
    }

    validateNino(part1, part2, part3){
        let v= part1 + part2 + part3
        if(v.length === 9 
            && this.part1IsValid(part1) 
            && this.part2IsValid(part2) 
            && this.part3IsValid(part3)){
            return true
        }else{
            return false
        }
    }

    componentDidMount() {        
        this.refs.part1.focus()
    }

    render() {
        return(
            <div className="nino">
                <span className={`hint--top hint--medium ${this.state.isNino1Error ? "hint--error" : ""}`} data-hint="First 2 Letters of NI number, e.g AA">
                    <input name="nino_1" ref="part1" type="text" maxLength="2" disabled={this.props.show_spinner}
                        minLength="2" size="4" placeholder="AB" value={this.state.part1} onChange={(e) => this.part1(e)}/>
                </span>
                <span className={`hint--top hint--medium ${this.state.isNino2Error ? "hint--error" : ""}`} data-hint="Middle 6 Numbers of NI number, e.g 123456">
                    <input name="nino_2" ref="part2" type="text" maxLength="6" disabled={this.props.show_spinner}
                        minLength="6" size="6" placeholder="123456" value={this.state.part2} onChange={(e) => this.part2(e)}/>
                </span>
                <span className={`hint--top hint--medium ${this.state.isNino3Error ? "hint--error" : ""}`} data-hint="Last Letter of NI number, e.g C">
                    <input name="nino_3" ref="part3" type="text" maxLength="1" disabled={this.props.show_spinner}
                        minLength="1" size="2" placeholder="C" value={this.state.part3} onChange={(e) => this.part3(e)}/>
                </span>
                <br/>
            </div>
            
        )
    }
}


export default connect( (props) => props ) (
    class extends React.Component {

        constructor(props) {
            super(props);            
            this.state = {nino: "", show_confirm_button: false, nino_not_found: null, show_spinner: false, is_locked_out: props.store.current_user.locked_out, verify_nino_locked_out: false, verification_failed: false, verification_attempts: props.store.current_user.verification_attempts, is_gibraltar_user: props.store.current_user.is_gibraltar_user}
        }

        locked_out_page() {
            return(
                <div id="main_content" style={{textAlign: "center"}} className="flex layout-column scrollable layout-align-center">
                    <img alt="morrisons logo" height="200" src={logo}></img>
                    <h1 style={{fontWeight: "normal", color: "#004E37", fontSize: "2em"}}>My Pay</h1>
                    <div style={{color: "red", textAlign: "center"}} className="message-container">
                        <span>Access to MyPay has temporarily been disabled for you. Please speak with your People Team who will be able to help you get this resolved.<br/> </span>
                    </div>

                    <br/>
                </div>
            )
        }


        nino_not_found() {
            return(
                <div id="main_content" style={{textAlign: "center"}} className="flex layout-column scrollable layout-align-center">
                    <img alt="morrisons logo" height="200" src={logo}></img>
                    <h1 style={{fontWeight: "normal", color: "#004E37", fontSize: "2em"}}>My Pay</h1>
                    <div style={{color: "red", textAlign: "center"}} >
                        <span>You do not have any payslips to view at this point in time. <br/> </span>
                        <span>Please come back and try again at your next pay day.<br/> </span>
                    </div>
                    <br/>
                </div>
            )                        
        }

        confirm() {
            this.setState({show_spinner: true})
                
            post( "/api/epayslips/verify", {"google_auth_token": this.props.store.google_oauth_token, nino: this.refs.nino.nino()}).then((data)=>{
                
                if ( data.locked_out ) {
                    return this.setState({show_spinner: false, verify_nino_locked_out: true})                        
                }

                if( data.nino_not_found ) {
                    return this.setState({ nino_not_found: true})
                }

                if ( data.verification_failed ) {      
                    console.log(data)              
                    this.setState({show_spinner: false, verification_failed: data.verification_failed, verification_attempts: data.verification_attempts})                        
                }
                else {
                    save({oauth_token: data.token})
                    save({current_user: {...data, ready: true}})                    
                }
            })
        }

        render() {


            if ( this.state.is_locked_out) return this.locked_out_page()
            if ( this.state.nino_not_found ) return this.nino_not_found()

            const attempts_remaining = 3 - +this.state.verification_attempts
                        
            return(
                <div id="main_content" style={{textAlign: "center"}} className="flex layout-column scrollable layout-align-center">
                    <img alt="morrisons logo" height="200" src={logo}></img>
                    <h1 style={{fontWeight: "normal", color: "#004E37", fontSize: "2em"}}>My Pay</h1>
                    { this.state.verify_nino_locked_out ? 
                        <div style={{color: "red", textAlign: "center"}} className="message-container">
                            <span>Unfortunately we have been unable to verify the details that you provided. Access to MyPay has been temporarily disabled. Please see a member of your People Team to resolve this. Your People Team will help you identify the issue and can send us a request to unlock your account.<br/> </span>
                        </div>
                        :
                        <div>
                            <span>Before accessing MyPay we need to do a one time validation check.<br/> </span>
                            <span>Please enter your { this.state.is_gibraltar_user ? "Social" : "National"} Insurance number below<br/> </span>
                            <span> in the following format<br/> </span>
                            <span><strong>{ this.state.is_gibraltar_user ? "123456" : "AB 123456 C"}</strong><br/> </span>
                            
                            { this.state.verification_failed ?
                                <div style={{color: "red", textAlign: "center"}}>
                                    <br/>

                                    <span>There seems to be a problem verifying your account.<br/> </span>
                                    <span>Please check and re-enter your { this.state.is_gibraltar_user ? "Social" : "National"} Insurance Number below.<br/> </span>
                                    <span>You have {attempts_remaining} more attempt{attempts_remaining === 1 ? "" : "s"}.<br/> </span>
                                </div>
                            : ""
                            } 
                            
                            <br/>

                            {this.state.is_gibraltar_user ?
                                <SinoInput ref="nino" onChange={(nino_valid)=> this.setState({show_confirm_button: nino_valid})} show_spinner={this.state.show_spinner}/>
                                :
                                <NinoInput ref="nino" onChange={(nino_valid)=> this.setState({show_confirm_button: nino_valid})} show_spinner={this.state.show_spinner}/>
                                }

                            <br/>
                            <br/>
                            {this.state.show_spinner ? 
                                <div className="spinner flex layout-column layout-align-center-center">
                                    <CircularProgress size={40} thickness={4} />
                                </div> : 

                                <RaisedButton disabled={!this.state.show_confirm_button} label="CONFIRM" primary={true} onClick={() => this.confirm()}/>
                            }
                        </div>
                    }
                    <br/>
                    <br/>
                </div>
            )
        }
    }
)




// WEBPACK FOOTER //
// ./src/pages/enter_your_nino.js